type Settings = {
  delimiter: string
}

const defaultSettings: Settings = {
  delimiter: ',',
}

export default function useUrlParams(settings: Settings = defaultSettings) {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const params: Record<string, string | string[]> = {}

  function extractValues() {
    for (const [key, value] of urlSearchParams.entries()) {
      const setValue: string[] | string = value.split(settings.delimiter)
      //Query params can be defined multiple times with the same name
      if (params[key] !== undefined) {
        params[key] = [...params[key], ...setValue]
      } else {
        params[key] = setValue
      }
    }
  }

  function reduceSingleArrays() {
    Object.entries(params).forEach(([k, v]) => {
      if (v.length === 1) {
        params[k] = v[0]
      }
    })
  }

  extractValues()
  reduceSingleArrays()

  return params
}
